import { ApiFile } from '@/shared'

export function getApiFileName(file: ApiFile) {
  if (!file?.file) return 'Название файла не найдено'

  const filePath = file.file

  // Пытаемся найти дату в различных форматах
  const datePatterns = [
    // YYYY_MM/YYYYMMDD_имя.расширение
    /(\d{4}[_-]\d{2}[_-]?\d{0,2})[_-]?(.+?)(?:\.[^.]+)?$/,
    // /путь/к/файлу/имя.расширение (берём последний сегмент)
    /\/([^/]+)$/
  ]

  for (const pattern of datePatterns) {
    const match = filePath.match(pattern)
    if (match) {
      // Если есть группа с именем файла (после даты), используем её
      const fileName = match[2] || match[1]
      if (fileName && !fileName.match(/^\d/)) {
        // проверяем, что это не просто дата
        try {
          return decodeURI(fileName)
        } catch {
          return fileName
        }
      }
    }
  }

  // Крайний случай: берём всё после последнего слеша
  const lastSlashIndex = filePath.lastIndexOf('/')
  if (lastSlashIndex !== -1) {
    const fileName = filePath.substring(lastSlashIndex + 1)
    try {
      return decodeURI(fileName)
    } catch {
      return fileName
    }
  }

  return 'Название файла не найдено'
}
